import { Typography } from '@mui/material'
import { formatThreeDecimalsCell, formatDateTimeCell } from '@/utils/cellFormat'
import { CustomColumnGridConfig } from '../types'

const columnsConfig: CustomColumnGridConfig[] = [
  {
    flex: 1,
    minWidth: 130,
    field: 'meterNumber',
    headerName: 'מספר מד',
    filter: { type: 'search' },
    filterable: true,
  },
  {
    flex: 1.2,
    minWidth: 140,
    field: 'timestamp',
    headerName: 'תאריך',
    hideable: true,
    disableAggregation: true,
    filter: { type: 'date' },
    filterable: true,
    format: formatDateTimeCell,
    renderCell: params => (
      <Typography sx={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px' }}>
        {params.formattedValue}
      </Typography>
    ),
  },
  // Hidden, not deleted: the hourly rows never fill these two columns.
  // {
  //   flex: 1,
  //   minWidth: 120,
  //   field: 'midnightCapacity',
  //   headerName: 'ק. חצות',
  //   filter: { type: 'aggregated' },
  //   filterable: true,
  // },
  // {
  //   flex: 1,
  //   minWidth: 120,
  //   field: 'backwardCapacity',
  //   headerName: 'ק. אחורה',
  //   filter: { type: 'aggregated' },
  //   filterable: true,
  // },
  {
    flex: 1,
    minWidth: 120,
    field: 'value',
    headerName: 'קריאה',
    filter: { type: 'aggregated' },
    filterable: true,
    format: formatThreeDecimalsCell,
  },
  {
    flex: 1,
    minWidth: 120,
    field: 'consumption',
    headerName: 'צריכה',
    filter: { type: 'aggregated' },
    filterable: true,
    format: formatThreeDecimalsCell,
  },
  {
    flex: 1.2,
    minWidth: 130,
    field: 'exception',
    headerName: 'חריגה',
    filter: { type: 'search' },
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 110,
    field: 'status',
    headerName: 'סטטוס',
    filter: { type: 'search' },
    filterable: true,
  },
]

export default columnsConfig
